import React, {useEffect, useState} from 'react';
import {
   Image,
   ImageBackground,
   Platform,
   SafeAreaView,
   ScrollView,
   StatusBar,
   StyleSheet,
   Text,
   TouchableOpacity,
   View,
} from 'react-native';
//import {AnimatedCircularProgress} from 'react-native-circular-progress';
import UICircularProgress from '../../components/circular-progress';
import Pulse from '../../utils/Pulse';
import {
   ALLCOURSE,
   appBackground,
   INSESSION,
   enrolledCoursesLength,
   overAllPercent,
   primaryColor500,
   primaryColor900,
   primaryState700,
   RECENT,
   white,
   FONT_FAMILY_REGULAR,
   getFullName,
   getNorcatId,
   getQRCode,
   REFRESH_DASHBOARD,
   isiOS,
} from '../../utils/utils';
import TabView from './TabView';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import ViewBarcode from '../../utils/ViewBarcode';
import logger from '../../utils/logger';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import RefreshDashBoardView from '../../utils/refreshDashboard';

const DashboardHeader = props => {
   const [selectedFilter, setSelectedFilter] = useState(ALLCOURSE);
   const isLandscapemode = useSelector(selectScreenOrientation);

   return (
      <SafeAreaView style={styles.container}>
         <View style={styles.headerTop}>
            <View
               style={{
                  flex: 1,
                  flexDirection: 'row',
                  alignItems: 'center',
               }}>
               <Image
                  source={require('../../assets/dashboard.png')}
                  style={{
                     width: 14,
                     height: 14,
                     marginEnd: 4,
                     tintColor: white,
                  }}
               />
               <Text
                  style={{
                     textAlignVertical: 'center',
                     color: white,
                     fontSize: 12,
                     marginLeft: 10,
                     fontWeight: '500',
                     fontFamily: FONT_FAMILY_REGULAR,
                     marginEnd: 8,
                  }}>
                  Dashboard
               </Text>
            </View>
            <View
               horizontal={true}
               style={{marginStart: 8, flexDirection: 'row'}}
               showsHorizontalScrollIndicator={false}>
               <TouchableOpacity
                  onPress={() => {
                     setSelectedFilter(ALLCOURSE);
                     props.onFilterClick(ALLCOURSE);
                  }}>
                  <TabView
                     isSelected={selectedFilter === ALLCOURSE ? true : false}
                     value="All Courses"
                  />
               </TouchableOpacity>
               <TouchableOpacity
                  onPress={() => {
                     setSelectedFilter(RECENT);
                     props.onFilterClick(RECENT);
                  }}>
                  <TabView
                     isSelected={selectedFilter === RECENT ? true : false}
                     value="Recent"
                  />
               </TouchableOpacity>
               {/* <TouchableOpacity
                  onPress={() => {
                     setSelectedFilter(INSESSION);
                     props.onFilterClick(INSESSION);
                  }}>
                  <TabView
                     isSelected={selectedFilter === INSESSION ? true : false}
                     value="In-Session"
                  />
               </TouchableOpacity> */}
               <TouchableOpacity
                  onPress={() => {
                     setSelectedFilter(selectedFilter);
                     props.onFilterClick(REFRESH_DASHBOARD);
                  }}>
                  <View
                     style={{
                        borderRadius: 100,
                        padding: 5,
                        //marginStart: 10,
                        backgroundColor: primaryState700,
                     }}>
                     {props.isDashboardRefresh ? (
                        <RefreshDashBoardView width={14} height={14} />
                     ) : (
                        <Image
                           source={require('../../assets/refresh_dashboard2.png')}
                           style={{width: 14, height: 14}}
                        />
                     )}
                  </View>
               </TouchableOpacity>
            </View>
            {/* <TouchableOpacity
               onPress={() => {
                  setSelectedFilter(ALLCOURSE);
                  props.onFilterClick(ALLCOURSE);
               }}>
               <View
                  style={{
                     borderRadius: 100,
                     padding: 5,
                     marginStart: 10,
                     backgroundColor: primaryState700,
                  }}>
                  <Image
                     source={require('../../assets/refresh_dashboard.png')}
                     style={{width: 14, height: 14}}
                  />
               </View>
            </TouchableOpacity> */}
         </View>
         <ImageBackground
            source={require('../../assets/profile_header_bg.png')}
            style={styles.headerTopBackground}>
            {/* <Svg
               height="200%"
               width="200%"
               style={StyleSheet.absoluteFillObject}>
               <Defs>
                  <LinearGradient id="grad" x1="0%" y1="100%" x2="0%" y2="0%">
                     <Stop offset="0%" stopColor="#003DA500" stopOpacity="0" />
                     <Stop offset="100%" stopColor="#001231" stopOpacity="1" />
                  </LinearGradient>
               </Defs>
               <Rect width="100%" height="100%" fill="url(#grad)" />
            </Svg> */}

            <View
               style={{
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
               }}>
               <UICircularProgress
                  size={78}
                  width={7}
                  fill={parseInt(overAllPercent(props.showPercentageData), 10)}
                  rotation={0}
                  tintColor="#26E555"
                  onAnimationComplete={() => logger('onAnimationComplete')}
                  background={true}
                  backgroundColor={primaryColor900}
                  trailStroke={primaryColor500}
                  showPercent={true}
                  imgWidth={24}
                  imgHeight={26}
                  iconBottomMargin={4}
                  iconTopMargin={0}
                  percentFont={!isLandscapemode ? 12 : 20}
                  fontWeight={'700'}
                  bgOpacity={1}
               />
               {/* <AnimatedCircularProgress
                  size={80}
                  width={7}
                  fill={parseInt(overAllPercent(props.showPercentageData))}
                  rotation={0}
                  tintColor="#26E555"
                  onAnimationComplete={() => logger('onAnimationComplete')}
                  backgroundColor="#003DA5">
                  {fill => (
                     <View
                        style={{
                           width: '100%',
                           height: '100%',
                           justifyContent: 'center',
                           alignItems: 'center',
                           backgroundColor: primaryColor900,
                        }}>
                        <Image
                           source={require('../../assets/course.png')}
                           style={{width: 25, height: 25}}
                        />
                        <Text
                           style={{
                              color: white,
                              fontSize: 12,
                              fontWeight: '700',
                              fontFamily: FONT_FAMILY_REGULAR,
                              marginTop: 8,
                           }}>
                           {`${parseInt(
                              overAllPercent(props.showPercentageData),
                           )}%`}
                        </Text>
                     </View>
                  )}
               </AnimatedCircularProgress> */}
               <View
                  style={{
                     flexDirection: 'column',
                     marginLeft: 10,
                     flex: 1,
                     paddingEnd: 5,
                  }}>
                  <TouchableOpacity
                     onPress={() => {
                        props.onProfileClick();
                     }}>
                     <Text
                        ellipsizeMode="tail"
                        //numberOfLines={3}
                        style={{
                           color: white,
                           fontSize: 14,
                           fontWeight: '700',
                           fontFamily: FONT_FAMILY_REGULAR,
                           width: '100%',
                        }}>
                        {getFullName(props.authData)}
                     </Text>
                  </TouchableOpacity>
                  <Text
                     style={{
                        color: white,
                        fontSize: 8,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        marginTop: 16,
                     }}>
                     NORCAT ID
                  </Text>
                  <Text
                     style={{
                        color: white,
                        width: '100%',
                        fontSize: 32,
                        marginTop: -5,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                     }}>
                     {getNorcatId(props.authData)}
                  </Text>
               </View>
            </View>
            <View style={{alignItems: 'center', justifyContent: 'center'}}>
               <Pulse />
               <TouchableOpacity
                  onPress={() => {
                     props.onQrClick();
                  }}>
                  <View
                     style={{
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                     }}>
                     <Image
                        source={{
                           uri:
                              'data:image/jpeg;base64,' +
                              getQRCode(props.authData), //props.authData.QRID,
                        }}
                        style={{height: 80, width: 80}}
                     />
                     <ViewBarcode />
                  </View>
               </TouchableOpacity>
            </View>
         </ImageBackground>
         <View style={styles.headerBottomBackground}>
            <Text
               style={{
                  flex: 1,
                  color: '#6E8EFF',
                  fontSize: 10,
                  fontWeight: '600',
                  fontFamily: FONT_FAMILY_REGULAR,
               }}>
               {props.subTitle}
            </Text>
            <Text
               style={{
                  color: white,
                  fontSize: 10,
                  fontWeight: isiOS ? null : '600',
                  fontFamily: isiOS ? 'Helvetica Neue' : FONT_FAMILY_REGULAR,
                  fontStyle: 'italic',
               }}>
               {`${props.showEnrolledCourses?.length} Enrolled courses.`}
            </Text>
         </View>
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {backgroundColor: appBackground},
   headerTopBackground: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      paddingVertical: 10,
      flexDirection: 'row',
      alignItems: 'center',
   },
   headerTop: {
      backgroundColor: '#001231',
      paddingHorizontal: 16,
      flexDirection: 'row',
      alignItems: 'center',
      height: 40,
   },
   headerBackground: {
      backgroundColor: '#001231',
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
   },
   headerBottomBackground: {
      backgroundColor: primaryColor900,
      paddingHorizontal: 16,
      paddingVertical: 6,
      flexDirection: 'row',
      alignItems: 'center',
   },
});

export default DashboardHeader;
